import SettingsModal from './settings-modal';

export default SettingsModal;